import { useParams } from "react-router-dom";
import ClientProgress from "./ClientProgress";

export default function ShareProgress() {
  const { clientId } = useParams();
  return <ClientProgress />;
}
